<template>

  <div class="user">


    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
       
        <el-form-item label="">
          <el-input v-model="formInline.order_search" placeholder="请输入订单编号/订单ID"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.user_search" placeholder="请输入分佣对象昵称"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.buser_search" placeholder="请输入购买人昵称"></el-input>
        </el-form-item>

        <el-form-item label="是否分佣">
          <el-select placeholder="是否分佣" v-model="formInline.is_ratio">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
        </el-form-item>



        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="order_id" label="订单ID" > </el-table-column>
            <el-table-column prop="order.order_no" label="订单编号" > </el-table-column>
            <el-table-column prop="user.nickName" label="分佣对象" > </el-table-column>
            <el-table-column prop="buser.nickName" label="购买人" > </el-table-column>
           
            <el-table-column prop="cardinal" label="当前基数" > </el-table-column>
            <el-table-column prop="sum_cardinal" label="达到分佣条件的基数" > </el-table-column>
            <el-table-column prop="min_achievement" label="最小值" > </el-table-column>
            <el-table-column prop="max_achievement" label="最大值" > </el-table-column>

            <el-table-column prop="teamuserone.nickName" label="团队一" >
              <template slot-scope="scope">
                {{ scope.row.teamuserone.nickName }} ({{ scope.row.teamuserone.user_id }})
            </template>
            </el-table-column>
            <el-table-column prop="team_user_one_money" label="团队一金额" > </el-table-column>
            <el-table-column prop="teamusertwo.nickName" label="团队一" >
              <template slot-scope="scope">
                {{ scope.row.teamusertwo.nickName }} ({{ scope.row.teamusertwo.user_id }})
            </template>
            </el-table-column>
            <el-table-column prop="team_user_two_money" label="团队二金额" > </el-table-column>
           
            <el-table-column prop="ratio" label="比例" > </el-table-column>
            <el-table-column prop="ratio_price" label="返佣金额" > </el-table-column>

            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>

          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import uacApi from '@/api/uac.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*当前编辑的对象*/
      userModel: {},
      formInline: {
        buser_search:"",
        order_search:"",
        user_search:"",
        is_ratio:-1,
      },


    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      console.log("------")
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;

      uacApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },



  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/cashdesk/index/index.vue